/* unplugin-vue-components disabled */import script from "./exchange.vue?vue&type=script&setup=true&lang=js"
export * from "./exchange.vue?vue&type=script&setup=true&lang=js"

import "./exchange.vue?vue&type=style&index=0&id=aa18da26&lang=less"

const __exports__ = script;

export default __exports__